import * as React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router";
import { DetailLayoutWrapper } from "../../components/sharedStyles";
import DetailPageHeaderMenu from "../Layouts/DetailPageHeaderMenu/DetailPageHeaderMenu";
import useActiveFilters from "../../hooks/useActiveFilters";
import { StatusLabel } from "../../components/Lists/Base/CompleteList/styles";
import { PrimaryButton } from "../../components/Forms/Base/Buttons";
import { usePermissionCheck } from "../../store/base";

import BrfCompanyModal from "../../components/Forms/BrfCompany/ChapterForm/ModalForm";
import { useBrfCompanyPaginationCount } from "../../store/brfCompanies/hooks/retrieve";
import BrfCompanies from "./overview/BrfCompanies";
import usePermissionRedirect from "../../hooks/usePermissionRedirect";
import PrimaryBtn from "src/components/Forms/Base/Buttons/PrimaryBtn";

export default function MainBrfCompanyOverview() {
  const { filteredRealEstates } = useActiveFilters();
  const { path, url } = useRouteMatch();
  const [createBrfOpen, setCreateBrfOpen] = React.useState(false);
  usePermissionRedirect(["allow_brf", "view_can_brf"]);

  const canAdd = usePermissionCheck("add_can_brf");

  const [brfCompanyCount] = useBrfCompanyPaginationCount({
    filters: { realestate_ids: filteredRealEstates },
  });

  const SUB_PAGES = [
    {
      path: "/overview",
      label: "Översikt",
      component: BrfCompanies,
    },
  ];

  const subPageLinks = SUB_PAGES.map((sp) => ({
    url: `${url}${sp.path}`,
    label: sp.label,
    hasError: sp.hasError,
  }));

  const renderInfoPills = () => {
    return (
      <>
        <StatusLabel state={0}>
          Antal BRF:er:{" "}
          {brfCompanyCount != null ? brfCompanyCount : "Laddar..."}
        </StatusLabel>
      </>
    );
  };

  const renderActions = () => (
    <>
      {canAdd && (
        <PrimaryBtn onClick={() => setCreateBrfOpen(true)}>
          Lägg till BRF
        </PrimaryBtn>
      )}
    </>
  );

  return (
    <>
      {createBrfOpen && (
        <BrfCompanyModal
          method="POST"
          onCheckout={() => setCreateBrfOpen(false)}
        />
      )}

      <DetailLayoutWrapper>
        <DetailPageHeaderMenu
          title={`Bostadsrättsföreningar`}
          {...{ subPages: subPageLinks, renderInfoPills, renderActions }}
        />

        <Switch>
          {SUB_PAGES.map((sp) => (
            <Route
              key={sp.path}
              path={`${path}${sp.path}`}
              component={sp.component}
            />
          ))}

          {/* Default sub page  */}
          <Redirect exact to={`${url}${SUB_PAGES[0].path}`} path={`${path}`} />
        </Switch>
      </DetailLayoutWrapper>
    </>
  );
}
